module.exports = __webpack_public_path__ + "static/media/clubhousemeadows_bg.4dbf2d7a.webp";